export const TABLE_SCROLLABLE_SIZE = 50;
